import React, { useContext, useState } from "react";
import TitleRow from "../../../../shared/components/TitleRow";
import { Product } from "../../../../data/entities";

interface TitleProps {
    title: string;
    data?: Product;
    setValidated?: (validate: boolean) => void;
    onSubmit?: Function;
}

const Title = ({ title }: TitleProps) => {
    return <TitleRow title={title} actions={[]} />;
};

export default Title;
